import React from 'react';
//import { Star } from 'lucide-react'; // Button, Card, CardContent, 
//import openWhatsApp from '../utils/whatsapp';

export const Suppliers = () => {
  const suppliers = [
    {
      id: 1,
      name: "Mikhail Rodríguez",
      specialty: "Mecánica general a domicilio",
      location: "Caracas, Venezuela",
      rating: 4.9,
      reviews: 127,
      experience: "15 años",
      availability: "Disponible",
      image: "/placeholder.svg",
      certifications: [""],
      priceRange: "Consultar"
    } ,
    {
      id: 2,
      name: "Claudio Caolo",
      specialty: "Mecánica ligera a domicilio",
      location: "Caracas, Venezuela",
      rating: 4.8,
      reviews: 89,
      experience: "Más de 5 años",
      availability: "Disponible",
      image: "/placeholder.svg",
      certifications: ["Electrical Systems", "Honda Certified"],
      priceRange: "Consultar"
    },
    {
      id: 3,
      name: "Ángel Quintero",
      specialty: "Mecánica general / Taller",
      location: "Baruta, Venezuela",
      rating: 4.7,
      reviews: 156,
      experience: "12 años",
      availability: "Disponible",
      image: "/placeholder.svg",
      certifications: ["Engine Specialist", "Transmission Expert"],
      priceRange: "Consultar"
    },
    {
      id: 4,
      name: "Alexis Maldonado",
      specialty: "Multimarcas / Taller",
      location: "Artigas-Caracas, Venezuela",
      rating: 4.9,
      reviews: 73,
      experience: "5 años",
      availability: "Disponible",
      image: "/placeholder.svg",
      certifications: ["HVAC Certified", "Climate Control"],
      priceRange: "Consultar"
    }
  ];

  const suppliers2 = [
    {
      id: 1,
      name: "Elio Comenarez",
      specialty: "Mecánica general a domicilio",
      location: "Barquisimeto,Lara,Venezuela",
      rating: 4.9,
      reviews: 127,
      experience: "Más de 5 años",
      availability: "Disponible",
      image: "/placeholder.svg",
      certifications: ["ASE Certified", "Toyota Specialist"],
      priceRange: "$20-45/hora"
    },
    {
      id: 2,
      name: "Edilson Eyco Jeep Automotriz",
      specialty: "Mecánica general/Taller",
      location: "Barquisiemto,Lara,Venezuela",
      rating: 4.8,
      reviews: 89,
      experience: "Más de 5 años",
      availability: "Disponible",
      image: "/placeholder.svg",
      certifications: ["Electrical Systems", "Honda Certified"],
      priceRange: "$25-50/hora"
    },
    {
      id: 3,
      name: "Omar Valdivieso",
      specialty: "Mecánica multimarcas / Taller",
      location: "Valencia,Carabobo,Venezuela",
      rating: 4.7,
      reviews: 156,
      experience: "Más de 5 años",
      availability: "Disponible",
      image: "/placeholder.svg",
      certifications: ["Engine Specialist", "Transmission Expert"],
      priceRange: "$30-60/hora"
    }
  ];

  return (
    <section id="proveedores" className="py-8 scroll-mt-12 bg-white dark:bg-gray-800">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Mecánicos verificados
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Profesionales auditados y calificados por nuestra comunidad de usuarios
          </p>
        </div>

        <div className="py-2 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {suppliers.map((supplier) => (
            <div
              key={supplier.id}
              className="group bg-white dark:bg-gray-800 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 p-6 space-y-4"
            >
              {/* Imagen de perfil circular + estado */}
              <div className="relative w-20 h-20 mx-auto">
                <div className="w-full h-full bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white text-2xl font-bold">
                  {supplier.name.split(' ').map(n => n[0]).join('')}
                </div>
                <div
                  className={`absolute -bottom-1 -right-1 w-6 h-6 rounded-full border-2 border-white ${
                    supplier.availability === 'Disponible' ? 'bg-green-500' : 'bg-red-500'
                  }`}
                ></div>
              </div>

              {/* Info básica */}
              <div className="text-center">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{supplier.name}</h3>
                <p className="text-blue-600 dark:text-blue-400 text-sm font-medium">{supplier.specialty}</p>
                <p className="text-sm text-gray-600 dark:text-gray-300">{supplier.location}</p>
              </div>

              {/* Calificación */}
              <div className="flex justify-center items-center gap-2 text-yellow-500 text-sm">
                <span>
                  {'★'.repeat(Math.round(supplier.rating)) +
                    '☆'.repeat(5 - Math.round(supplier.rating))}
                </span>
                <span className="text-gray-500 dark:text-gray-400">({supplier.reviews})</span>
              </div>

              {/* Detalles */}
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-600 dark:text-gray-300">Experiencia:</span>
                  <span className="font-medium text-gray-900 dark:text-white">{supplier.experience}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600 dark:text-gray-300">Estado:</span>
                  <span
                    className={`font-medium ${
                      supplier.availability === 'Disponible' ? 'text-green-600' : 'text-red-500'
                    }`}
                  >
                    {supplier.availability}
                  </span>
                </div>
              </div>

              {/* Botones de acción */}
              <div className="pt-4 border-t space-y-2">
                <button
                  className={`w-full py-2 rounded-lg font-medium transition-colors ${
                    supplier.availability === 'Disponible'
                      ? 'bg-blue-600 text-white hover:bg-blue-700'
                      : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                  }`}
                  disabled={supplier.availability !== 'Disponible'}
                >
                  {supplier.availability === 'Disponible' ? 'Contratar' : 'No Disponible'}
                </button>
                <button
                  className="w-full py-2 border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50 dark:hover:bg-blue-900/20 text-sm font-medium"
                >
                  Ver Perfil
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="py-2 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {suppliers2.map((supplier2) => (
            <div
              key={supplier2.id}
              className="group bg-white dark:bg-gray-800 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 p-6 space-y-4"
            >
              {/* Imagen de perfil circular + estado */}
              <div className="relative w-20 h-20 mx-auto">
                <div className="w-full h-full bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white text-2xl font-bold">
                  {supplier2.name.split(' ').map(n => n[0]).join('')}
                </div>
                <div
                  className={`absolute -bottom-1 -right-1 w-6 h-6 rounded-full border-2 border-white ${
                    supplier2.availability === 'Disponible' ? 'bg-green-500' : 'bg-red-500'
                  }`}
                ></div>
              </div>

              {/* Info básica */}
              <div className="text-center">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{supplier2.name}</h3>
                <p className="text-blue-600 dark:text-blue-400 text-sm font-medium">{supplier2.specialty}</p>
                <p className="text-sm text-gray-600 dark:text-gray-300">{supplier2.location}</p>
              </div>

              {/* Calificación */}
              <div className="flex justify-center items-center gap-2 text-yellow-500 text-sm">
                <span>
                  {'★'.repeat(Math.round(supplier2.rating)) +
                    '☆'.repeat(5 - Math.round(supplier2.rating))}
                </span>
                <span className="text-gray-500 dark:text-gray-400">({supplier2.reviews})</span>
              </div>

              {/* Detalles */}
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-600 dark:text-gray-300">Experiencia:</span>
                  <span className="font-medium text-gray-900 dark:text-white">{supplier2.experience}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600 dark:text-gray-300">Estado:</span>
                  <span
                    className={`font-medium ${
                      supplier2.availability === 'Disponible' ? 'text-green-600' : 'text-red-500'
                    }`}
                  >
                    {supplier2.availability}
                  </span>
                </div>
              </div>

              {/* Botones de acción */}
              <div className="pt-4 border-t space-y-2">
                <button
                  className={`w-full py-2 rounded-lg font-medium transition-colors ${
                    supplier2.availability === 'Disponible'
                      ? 'bg-blue-600 text-white hover:bg-blue-700'
                      : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                  }`}
                  disabled={supplier2.availability !== 'Disponible'}
                >
                  {supplier2.availability === 'Disponible' ? 'Contratar' : 'No Disponible'}
                </button>
                <button
                  className="w-full py-2 border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50 dark:hover:bg-blue-900/20 text-sm font-medium"
                >
                  Ver Perfil
                </button>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};